import {ActionHandlerBase} from "../action-handler-base";
import {ActionID, AppIdentifiers, IPerformActionTopicPayload, ProductPackageToID} from "@sparkware/uc-sdk-core";
import {Check} from "@sparkware/app-utils";
import {IFormPostParams} from "../../../dom/dom.service.interface";
import {
    getCasinofiedCommonAppContextParams,
    getCasinofiedDeviceInfo,
    getCasinofiedGeoInfoParams
} from "../../casinofied-helper-functions";

export class OpenLinkWithFormPostActionHandler extends ActionHandlerBase {
    async handle(payload: IPerformActionTopicPayload): Promise<void> {

        this._sendAnalytics(payload);

        if (!this.services.user.isAuthorized || this.services.device.hybrid.isHybrid) {
            return this._performFormPost(payload);
        }

        return this.services.user.getPlatformToken().then(platformToken => {
            return this._performFormPost(payload, platformToken.token);
        });
    }

    private _shouldOpenInSameWindow(): boolean {
        return !this.services.device.hybrid.isHybrid && this.services.device.isMobile;
    }

    private _performFormPost(payload: IPerformActionTopicPayload, token?: string): Promise<void> {

        const formPostExtraParams = {
            relatedAccountCid: payload.actionData.relatedAccountCid,
            registrationCategory: payload.actionData.registrationCategory,
            correlationId: payload.actionData.correlationId
        };

        if (!Check.isNullOrUndefined(token)) {
           Object.defineProperty(formPostExtraParams, "t", {
               value: token,
               enumerable: true
           });
        }

        const formPostParams: IFormPostParams = {
            url: payload.actionData.url,
            method: "post",
            extraParams: formPostExtraParams
        };

        if (this._shouldOpenInSameWindow()) {
            formPostParams.target = '_self';
        }

        this.services.dom.performFormPost(formPostParams);

        return Promise.resolve();
    }

    private async _sendAnalytics(payload: IPerformActionTopicPayload): Promise<void> {
        const isEmail = payload.actionID === ActionID.openEmail;
        const appId = isEmail ? AppIdentifiers.OpenEmail : AppIdentifiers.OpenOnlineHelp;
        const productPackageToID = isEmail ? ProductPackageToID.OPEN_EMAIL : ProductPackageToID.OPEN_ONLINE_HELP;

        this.services.casinofiedAnalytics.openAppRequest({
            correlationID: payload.correlationID,
            launchInfo: payload.launchInfo,
            appID: appId,
        });

        const geoInfo = await getCasinofiedGeoInfoParams(this.services);
        this.services.casinofiedAnalytics.appInitRequest({
            correlationID: payload.correlationID,
            applicationContext: {
                launchInfo: payload.launchInfo,
                appID: appId,
                productPackageToID: productPackageToID,
                ...getCasinofiedCommonAppContextParams(this.services)

            },
            deviceInfo: getCasinofiedDeviceInfo(this.services),
            geoInfo: geoInfo,
            userInfo: {
                userMode: this.services.user.isAuthorized ? 'authenticated' : 'anonymous',
                regulationTypeID: this.services.regulation.getRegulationCode(),
                token: ''
            },
            messageBrokerChannels: this.services.messageBroker.channels
        });
    }
}